// extracted by mini-css-extract-plugin
export var inSearchInputPlaceholder = "GgHzM";
export var inputPlaceholder = "EmdGf";
export var isDisabled = "h5M4N";
export var searchBoxInput = "uz227";
export var searchBoxInputContainer = "rclHC";
export var win32SearchBoxInput = "OiyDj";